import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/jsx-no-bind */
/* eslint-disable react/display-name */
import { useEffect, useState } from 'react';
import { DatePicker } from '@alife/cn-ui';
const { RangePicker } = DatePicker;
export default (props) => {
    const { visible, onVisibleChange, onChange, value, isDate } = props;
    const [rangeValue, setRangeValue] = useState();
    function onOk(values) {
        const [start, end] = values;
        let startText = start;
        let endText = end;
        const format = isDate ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm:ss';
        if (start && typeof start === 'object') {
            startText = start.format(format);
        }
        if (end && typeof start === 'object') {
            endText = end.format(format);
        }
        onChange([startText, endText], [startText, endText]);
    }
    useEffect(() => {
        const { values = [] } = value || {};
        if (values && values.length) {
            const [start] = values;
            // 如果是日期格式，才复制给 rangeValue
            if (/^[1-9]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/.test(start)) {
                setRangeValue(values);
            }
        }
    }, [value]);
    return (_jsx("div", { style: { position: 'absolute' }, children: _jsx(RangePicker, { popupClassName: 'custom-date-picker', style: { visibility: 'hidden' }, visible: visible, showTime: !isDate
                ? {
                    defaultValue: ['00:00:00', '23:59:59'],
                    format: 'HH:mm:ss',
                }
                : false, hasClear: true, onVisibleChange: onVisibleChange, onOk: onOk, value: rangeValue, onChange: (v) => setRangeValue(v) }) }));
};
